import type { Fleet, Session, SessionUser } from '@cobliteam/common-types';
import moment from 'moment';
import { severinoDateFormat } from '../severino';
import type { SessionAPI } from './ApiTypes';

export const transformSession = (session: SessionAPI): Session => {
  const id = session.session_id;
  const sessionUser = session.user;
  const sessionFleet = session.user.fleets[0];
  const authenticationToken = session.authentication_token;

  const user: SessionUser = {
    id: sessionUser.id,
    name: sessionUser.fullname,
    role: sessionUser.role,
    language: sessionUser.language,
    lastLogin: sessionUser.last_login ? moment(sessionUser.last_login, severinoDateFormat).valueOf() : undefined,
    email: sessionUser.email,
    creationDate: sessionUser.creation_date ? moment(sessionUser.creation_date, severinoDateFormat).valueOf() : undefined,
    timezone: sessionUser.timezone,
    groupsRestriction: sessionUser.groups_restriction,
    grantedPermissions: sessionUser.granted_permissions,
    phoneNumber: sessionUser.phone_number,
  };

  const fleet: Fleet = {
    id: sessionFleet.id,
    name: sessionFleet.name,
    active: sessionFleet.active,
  };

  return { id, user, fleet, authenticationToken };
};

export default transformSession;
